<script>
export default {
  props: {
    applications: [Array, Object]
  },
  computed: {
    phases() {
      return this.$store.getters['admin/opportunities/orderedPhases']
    },
    current() {
      let status = null
      if (this.applications && this.applications.status) {
        status = this.applications.status
      }
      if (this.applications && this.applications[0]) {
        status = this.$store.getters['admin/applications/find'](this.applications[0]).status
      }
      if (status) {
        return {
          name: status,
          index: this.phases.findIndex(p => status === p.name),
        }
      } else {
        return {
          name: 'Unknown',
          index: -1,
        }
      }
    },
    prev() {
      if (this.current && this.current.index > 0) {
        return this.phases.slice(0, this.current.index)
      }
      return []
    },
    next() {
      const length = this.phases.length
      if (this.current && this.current.index < length) {
        return this.phases.slice(this.current.index + 1)
      }
      return this.phases
    },
    canRegret() {
      return this.current && this.current.name !== 'Unsuccessful'
    }
  },
  render() {
    return this.$scopedSlots.default({
      phases: this.phases,
      prev: this.prev,
      next: this.next,
      canRegret: this.canRegret
    })
  }
}
</script>
